import { render, staticRenderFns } from "./PassBox.vue?vue&type=template&id=2050dbb2&scoped=true&"
import script from "./PassBox.vue?vue&type=script&lang=js&"
export * from "./PassBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050dbb2",
  null
  
)

export default component.exports